<template>
  <div class="d-flex justify-content-center align-items-center h-100">
    <h2>Seja bem-vindo ao Portal de Relatórios</h2>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
